import {mainUrl, guruId} from "../../../api/apiSettings";

export const NEWS_GET_SPECIFIC =(uniqueId) => `${mainUrl}/news/${uniqueId}`;

export const NEWS_QUERY = `${mainUrl}/news/`;
export const NEWS_GET_IMAGE = (uniqueId) => `${mainUrl}/news/image/${uniqueId}`;
